import { StrictLocalizeFunction } from "../localization";

import { ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS as _ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS } from "./ISO_TO_COUNTRY_NAME";

/**
 * All countries, in localized order.
 */
export const COUNTRY = (strictLocalize: StrictLocalizeFunction) => {
  const ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS =
    _ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS(strictLocalize);
  return Object.keys(ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS).map((key) => ({
    value: key,
    // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
    label: ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS[key],
  }));
};
